import ModelTypeConstants from 'constants/ModelTypeConstants';
import {parseFolderItemIdFromURL} from 'folder-items/FileUtil';
import APIUtil from 'util/APIUtil';

function parseTokenAsApiId(token: string): string | null {
  const trimmed = token.trim();
  if (trimmed.length === 0) {
    return null;
  }
  return parseFolderItemIdFromURL(trimmed) ?? trimmed;
}

/**
 * Parses comma- or whitespace-separated API IDs.
 *
 * Returns a list of API IDs if every token matches the given model type.
 *
 * @package
 */
export function parseApiIdsClipboardContent(
  text: string,
  modelType: ModelTypeConstants
): Array<string> | null {
  const apiIds = text
    .split(/[,\s]+/)
    .map((token) => parseTokenAsApiId(token))
    .filter((apiId): apiId is string => apiId != null);
  if (apiIds.length === 0 || !apiIds.every((apiId) => APIUtil.apiIdToMaybeType(apiId) === modelType)) {
    return null;
  }
  return apiIds;
}
